export const aggregate3Signature = '0x82ad56cb';
//# sourceMappingURL=contract.js.map